import React from "react";

import Default from "../../assets/image_default.jpg";
import styles from "./styles.module.scss";

export interface IProps {
  url: string;
  thumbnailUrl?: string;
  onClick: (url: string) => void;
  alt?: string;
}

/**
 * This component will be displayed in the gallery and should be passed
 * the url to the SMALL version of a gallery image.
 *
 * @param props See 'IProps'
 */
const GalleryImage: React.FC<IProps> = (props) => {
  return (
    <div className={styles.container}>
      <a onClick={() => props.onClick(props.url)}>
        <img src={props.thumbnailUrl || Default} alt={props.alt} />
      </a>
    </div>
  );
};

export default GalleryImage;
